import { Box, Stack } from '@mui/joy';
import { ICellRendererParams } from 'ag-grid-community';

import { IManufacturerOption } from 'bom/types';
import { TextLine } from 'core/elements';

const PossibleManufacturerCell = ({ data }: ICellRendererParams) => {
  const lines = data?.possibleManufacturers.map(
    (possibleManufacturer: IManufacturerOption, index: number) => (
      <Box key={index}>
        <TextLine text={possibleManufacturer.manufacturerName} textEllipsis bold />
        <TextLine text={possibleManufacturer.partDescription} textEllipsis isSubText />
      </Box>
    )
  );

  return <Stack>{lines}</Stack>;
};

export default PossibleManufacturerCell;
